import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TrackerDashboard from './components/TrackerDashboard';
import TrackerDetail from './components/TrackerDetail';
import CreateTracker from './components/CreateTracker';
import ImportList from './components/ImportList';
import CreateMondayTracker from './components/CreateMondayTracker';

const Tracker = () => {
  return (
    <Routes>
      <Route path="/" element={<TrackerDashboard />} />
      <Route path="/new" element={<CreateTracker />} />
      <Route path="/import" element={<ImportList />} />
      <Route path="/:id" element={<TrackerDetail />} />
      <Route path="/new-monday" element={<CreateMondayTracker />} />
    </Routes>
  );
};

export default Tracker; 